export const seatsIOPublicKey =
  process.env.SEATS_IO_PUBLIC_KEY || 'publicDemoKey';
